export const getTokensForPlatform = (state, platform) => { var _a; return (_a = state.publish.platforms[platform]) === null || _a === void 0 ? void 0 : _a.auth; };
export const isPlatformAuthorized = (state, platform) => {
    const token = getTokensForPlatform(state, platform);
    if (!token) {
        return false;
    }
    if (token.expiresAt) {
        const now = new Date();
        const expiryDate = new Date(token.expiresAt * 1000);
        if (now.getTime() > expiryDate.getTime()) {
            return false;
        }
    }
    return true;
};
export const isPublishingToPlatform = (state, platform) => {
    var _a;
    const platformState = state.publish.platforms[platform];
    return ((_a = platformState === null || platformState === void 0 ? void 0 : platformState.job) === null || _a === void 0 ? void 0 : _a.state) === 'publishing';
};
export const getPublishJob = (state, platform) => {
    const platformState = state.publish.platforms[platform];
    return platformState === null || platformState === void 0 ? void 0 : platformState.job;
};
export const getSelectedPlatform = (state) => state.publish.selected;
